<template>
    <div class="container">
        <div class="bg" />
        <div class="nav_san" @click="show = !show">
            <img src="../../../assets/image/one/hunt_nav.png" alt="">
        </div>
        <div class="header flex">
            <div class="header_le">
                <img src="../../../assets/image/one/hunt_logo.png" alt="">
            </div>
            <div class="header_ri flex">
                <!-- <div class="flex">
                    <img src="../../../assets/image/one/hunt_avatar.png" alt="">
                    <span>{{ user.member_name || '**' }}</span>
                </div> -->

                <div class="flex ml20" @click="goNav('HomeLang')">
                    <img src="../../../assets/image/one/hunt_lang.png" alt="">
                    <span>{{ $t('hunt12') }}</span>
                </div>
            </div>
        </div>

        <div class="banner">
            <img src="../../../assets/image/one/hunt_banner.png" alt="">
        </div>

        <div class="usd">
            <div class="usd_box" v-for="(el, index) in UsdList" :key="index" @click="goNav('HuntGoods', el)">
                <img :src="require(`../../../assets/image/one/hunt_usd/${el}.png`)" alt="">
                <span>USD{{ $t('hunt11') }}</span>
            </div>
        </div>

        <div class="exc" @click="goNav('HuntConvert')">
            <img src="../../../assets/image/one/hunt_exc.png" alt="">
        </div>

        <div class="news">
            <div class="news_tag">
                <div class="news_tag_box">
                    <img src="../../../assets/image/one/hunt_tag.png" alt="">
                    <!-- <div>{{ $t('hunt13') }}</div> -->
                    {{ $t('hunt13') }}
                </div>
            </div>
            <div class="news_list">
                <div class="news_list_box" v-for="(el, index) in newsList.data" @click="goNav('HuntNews')" :key="index">
                    <div>{{ el.title || '' }}</div>
                    <span>{{ el.created_time || '' }}</span>
                </div>
            </div>
        </div>

        <van-popup v-model="show" :overlay="false" position="right" class="popup_ri">
            <div class="nav flex">
                <img @click="show = !show" src="../../../assets/image/one/nav_/close.png" alt="">
                <span>{{ $t('hunt14') }}</span>
            </div>

            <div class="nav_box flex" v-for="el in navList" :key="el" @click="goNav(el.nav)">
                <img :src="el.url" alt="">
                <span>{{ el.name }}</span>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { UsdList, noticeList, GetCycleList } from '../../../api/memberOne'
// import { getMemberIndex } from '../../../api/member'
export default {
    name: 'HuntIndex',
    data() {
        return {
            usd: [
                {
                    img: '100@2x.png'
                },
                {
                    img: '300@2x.png'
                },
                {
                    img: '500@2x.png'
                },
                {
                    img: '1000@2x.png'
                },
                {
                    img: '3000@2x.png'
                },
                {
                    img: '5000@2x.png'
                },
                {
                    img: '10000@2x.png'
                },
                {
                    img: '30000@2x.png'
                },
                {
                    img: '50000@2x.png'
                },
                {
                    img: '100000@2x.png'
                },
                {
                    img: '300000@2x.png'
                },
                {
                    img: '500000@2x.png'
                },
            ],
            navList: [
                {
                    url: require(`../../../assets/image/one/nav_/gg.png`),
                    name: this.$t('hunt15'),
                    nav: 'HuntNews',
                },
                // {
                //     url: require(`../../../assets/image/one/nav_/db.png`),
                //     name: this.$t('hunt16'),
                //     nav: 'HuntNotes',
                // },
                {
                    url: require(`../../../assets/image/one/nav_/jh.png`),
                    name: this.$t('hunt17'),
                    nav: 'HuntShipPing',
                },
                {
                    url: require(`../../../assets/image/one/nav_/gz.png`),
                    name: this.$t('hunt18'),
                    nav: 'HuntRule'
                },
                {
                    url: require(`../../../assets/image/one/nav_/dx.png`),
                    name: this.$t('hunt19'),
                    nav: 'HuntConvert'
                },
                {
                    url: require(`../../../assets/image/one/nav_/lx.png`),
                    name: this.$t('hunt20'),
                    nav: 'HuntLink'
                }
            ],
            UsdList: [],
            show: false,
            page: 1,
            limit: 5,
            newsList: [],
            user: {}
        }
    },
    components: {

    },
    created() {
        const token = this.$route.query.token;
        sessionStorage.setItem('token', token)
        this.getUsdList()
        this.getNews()
        // this.getUser()
    },
    methods: {
        goNav(name = 'HuntIndex', val) {
            this.$router.push({ name: name, query: { data: val } })
        },
        getUsdList() {
            UsdList({}).then(res => {
                if (res && res.result) {
                    this.UsdList = res.result.data
                }
            }, error => { })
        },
        getNews() {
            const { page, limit } = this
            noticeList({
                page: page,
                limit: limit,
            }).then(res => {
                if (res && res.result) {
                    this.newsList = res.result
                }
            })
        },
        // getUser(){
        //     getMemberIndex().then(
        //         response => {
        //         if (response && response.result.member_info) {
        //             this.user = response.result.member_info
        //         }
        //         },
        //         error => { }
        //     )
        // }
    }
}
</script>

<style scoped lang="scss">
.container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #F9F9F9;
    text-align: center;
    padding-bottom: 3rem;
    padding: 0 10px;
    position: relative;
    box-sizing: border-box;

    .bg {
        position: absolute;
        top: 0;
        width: 100%;
        left: 0;
        z-index: 0;
        height: 251px;
        background: url('../../../assets/image/one/hunt_bg.png') no-repeat;
        background-size: cover;
        background-position: top;
    }

    .flex {
        display: flex;
    }

    .nav_san {
        margin-top: 2rem;
        text-align: right;
        z-index: 1;

        img {
            width: 18px;
            height: 18px;
        }
    }

    .header {
        align-items: center;
        justify-content: space-between;
        margin-top: 5px;
        z-index: 1;

        .header_le {
            img {
                height: 38px;
            }
        }

        .header_ri {
            font-size: 12px;
            color: #333333;

            .ml20 {
                margin-left: 20px;
            }

            img {
                width: 15px;
                height: 15px;
                margin-right: 2px;
            }
        }

    }

    .banner {
        z-index: 1;
        height: 156px;
        margin: 10px 0;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .usd {
        height: 302px;
        background: url('../../../assets/image/one/hunt_usdbg.png') no-repeat;
        background-size: cover;
        padding: 35px 17px 20px;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(4, 1fr);

        .usd_box {
            width: 81px;
            height: 78px;
            background: url('../../../assets/image/one/hunt_usdbox.png') no-repeat;
            background-size: cover;
            padding: 40px 10px 10px;
            box-sizing: border-box;
            color: #FBF99B;
            font-size: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            img {
                height: 12px;
            }
        }
    }

    .exc {
        height: 103px;
        padding: 10px 0;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .news {
        border-radius: 8px;
        width: 100%;
        margin-bottom: 100px;
        background: #fff;
        padding: 10px 8px;
        box-sizing: border-box;

        .news_tag {
            display: flex;
            justify-content: flex-start;
            margin-bottom: 16px;
        }

        .news_tag_box {
            height: 24px;
            position: relative;
            padding: 0 40px 0 12px;
            display: inline-block;
            z-index: 1;
            font-size: 15px;
            color: #fff;
            line-height: 24px;

            img {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: -1;
            }
        }

        .news_list {
            display: flex;
            flex-direction: column;

            .news_list_box {
                display: flex;
                align-items: center;
                color: #999;
                font-size: 12px;
                margin-bottom: 10px;

                div {
                    color: #333;
                    font-weight: bold;
                    flex: 1;
                    text-align: left;
                    font-size: 14px;
                }
            }
        }
    }

    .popup_ri {
        height: 100%;
        background: rgba(0, 0, 0, .9);
        width: 50%;
        padding: 23px 13px;
        box-sizing: border-box;
        font-size: 15px;
        color: #fff;

        .nav {
            align-items: center;
            margin-bottom: 22px;

            img {
                width: 14px;
                height: 14px;
                margin-right: 11px;
            }
        }

        .nav_box {
            padding: 0 30px 30px;
            align-items: center;

            img {
                width: 15px;
                height: 15px;
                margin-right: 10px;
            }
        }
    }
}
</style>